import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HouseDialog } from "@/components/site/HouseDialog";
import { POLICIES } from "@/components/site/siteData";

export const RulesDialog = ({ open, onOpenChange, onAgree }) => (
  <HouseDialog
    open={open}
    onOpenChange={onOpenChange}
    title="The House Rules ♛"
    description="Please read before you request your chair."
    testId="rules-dialog"
  >
    <Accordion type="single" collapsible className="policies">
      {POLICIES.map(([t, d], i) => (
        <AccordionItem key={t} value={t} className="policy-item">
          <AccordionTrigger className="policy-trigger" data-testid={`rules-policy-${i}`}>{t}</AccordionTrigger>
          <AccordionContent className="policy-body">{d}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
    {onAgree ? (
      <button type="button" className="cta mt-5" onClick={onAgree} data-testid="rules-agree-button">
        I've read & agree to the House Rules
      </button>
    ) : null}
  </HouseDialog>
);
